import "core-js/modules/es.array.concat";
import { base64Encode } from "web/script/utils/json";
/**
 * Utility function to return the mark up to use for icon
 * @param name Name of icon to use
 */

export function svgIcon(name) {
  return "\n        <svg class=\"svg-icon svg-icon-".concat(name, "\">\n            <use xlink:href=\"#").concat(name, "\"></use>\n        </svg>\n    ");
}
/**
 * Utility function to install new filters into the Jinja-to-JS runtime.
 */

export function installJinjaFilters(jinjaToJs) {
  jinjaToJs.filters.base64_json = base64Encode;
  jinjaToJs.filters.svg_icon = svgIcon;
}